import { render, staticRenderFns } from "./Coverband.vue?vue&type=template&id=02aeffae&"
import script from "./Coverband.vue?vue&type=script&lang=js&"
export * from "./Coverband.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports